import React from 'react';
import { arrayOf, bool, func, number, oneOfType, shape } from 'prop-types';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';

import { Tune as FilterIcon, ListAlt as ListIcon, Map as MapIcon } from '@mui/icons-material';

const styles = {
  filterChip: {
    '> .MuiChip-label': {
      px: 0.75,
      py: 0.25,
    },
    backgroundColor: 'primary.light',
    borderWidth: '1px',
    fontSize: '12px',
    height: 'unset',
    mb: 0.5,
    ml: -1,
    mr: 0,
    my: 0,
    px: 0,
    py: 0.25,
  },
  mobileHeader: {
    '> .MuiButtonBase-root': {
      color: 'secondary.main',
      height: 40,
      width: 40,
    },
    alignItems: 'center',
    display: { lg: 'none', xs: 'flex' },
    p: 2,
  },
};

const TerminalLocatorMobileHeader = ({
  SetLocation,
  filterCount,
  mapViewHook: [mapView, setMapView],
  mobileDrawerHook: [, setDrawerOpen],
  sx,
  ...props
}) => (
  <Box sx={{ ...styles.mobileHeader, ...sx }} {...props}>
    <SetLocation label="Set Location" sx={{ flex: 1 }} />
    <IconButton onClick={() => setDrawerOpen(true)}>
      <FilterIcon sx={{ transform: 'rotate( 90deg )' }} />
    </IconButton>
    {!!filterCount && <Chip label={filterCount} sx={styles.filterChip} />}
    <IconButton onClick={() => setMapView(b => !b)}>
      {mapView ? <ListIcon /> : <MapIcon />}
    </IconButton>
  </Box>
);

TerminalLocatorMobileHeader.propTypes = {
  SetLocation: func.isRequired,
  filterCount: number,
  mapViewHook: arrayOf(oneOfType([bool, func])).isRequired,
  mobileDrawerHook: arrayOf(oneOfType([bool, func])).isRequired,
  sx: shape({}),
};

TerminalLocatorMobileHeader.defaultProps = {
  filterCount: 0,
  sx: null,
};

export default TerminalLocatorMobileHeader;
